import React, { useState, useEffect } from "react";
import { Navbar, Nav, Row, Col, Dropdown } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/rs-logo.png";
import SvgTriggerDropdown from "../components/SvgTriggerDropdown";

const Header = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const navLinks = [
    { path: "/", label: "Home", hasSubmenu: false },
    { path: "/journals", label: "Journals", hasSubmenu: false },
    { path: "/archives", label: "Archives", hasSubmenu: false },
    { path: "/guide", label: "Author Guidelines", hasSubmenu: false },
    {
      path: "/about",
      label: "About Us",
      hasSubmenu: true,
      submenu: [
        { path: "/about/ruisi-global", label: "About RUISI-GLOBAL" },
        { path: "/about/contact_us", label: "Contact Us" },
      ],
    },
  ];

  const location = useLocation();
  const [aboutShow, setAboutShow] = useState(false);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isParentRouteActive = (parentPath) => {
    return location.pathname.startsWith(parentPath);
  };

  return (
    <Navbar
      bg="light"
      expand="lg"
      className="nav-top"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
      variant="dark"
    >
      <Row className="align-items-center container" style={{ width: "100%" }}>
        <Col xs={12} lg={3} className="d-flex align-items-center">
          <Navbar.Brand as={NavLink} to="/" style={{ padding: 0 }}>
            <div className="header-logo">
            <img
              src={logo}
              style={{ maxHeight: "60px" }}
              alt="RUISI-GLOBAL Logo"
            />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="ms-auto d-lg-none"
          />
        </Col>
        <Col xs={12} lg={1}></Col>
        <Col xs={12} lg={8}>
          <Navbar.Collapse id="basic-navbar-nav">
            <Row className="align-items-center" style={{ width: "100%",justifyContent:"space-between" }}>
              {navLinks.map((link, index) =>
                !link.hasSubmenu ? (
                  <Col xs={12} md="auto" key={index}>
                    <Nav.Link
                      as={NavLink}
                      to={link.path}
                      end
                      onClick={handleScrollToTop}
                      className="px-3 py-2"
                    >
                      {link.label}
                    </Nav.Link>
                  </Col>
                ) : (
                  <Col xs={12} md="auto" key={index}>
                    <Dropdown
                      show={aboutShow}
                      onToggle={(isOpen) => setAboutShow(isOpen)}
                      className="px-3 py-2"
                    >
                      <Dropdown.Toggle
                        as="div"
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          color: isParentRouteActive(link.path)
                            ? "rgb(247, 147, 30)"
                            : "#fff",
                        }}
                      >
                        {link.label}
                        <FontAwesomeIcon
                          icon={aboutShow ? faChevronUp : faChevronDown}
                          size="sm"
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {link.submenu.map((subItem, subIndex) => (
                          <Dropdown.Item
                            as={NavLink}
                            to={subItem.path}
                            key={subIndex}
                            onClick={handleScrollToTop}
                            className="px-4 py-2"
                          >
                            {subItem.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                )
              )}
            </Row>
          </Navbar.Collapse>
        </Col>
      </Row>
    </Navbar>
  );
};

export default Header;
